import { FunctionalComponent, h } from "@stencil/core";
import { CountryData } from "./regions";

interface RegionItemProps {
    active?: boolean;
    baseClass: string;
    onSelect: (countryCode: string) => void;
    region: CountryData;
}

const RegionItem: FunctionalComponent<RegionItemProps> = ({ active, baseClass, onSelect, region }) => {
    const { country, label, prefix } = region;
    return (
        <li
            class={{
                [`${baseClass}__option`]: true,
                // @ts-expect-error Check for typing
                ["is-active"]: active
            }}
            onClick={() => onSelect(country)}
            role="option"
            aria-selected={active}
        >
            <ux-country-icon country={country} size="s" />
            {label}
            {prefix && ` (+${prefix})`}
        </li>
    );
};

export default RegionItem;
